module.exports = __webpack_public_path__ + "img/system29-details.1987e78e.png";